<template>
  <b-card class="card-wrapper shadow">
    <b-row align-v="center" class="py-3">
      <b-col cols="2">
        <b-card-img class="img-card" :src="getUrl()"></b-card-img>
      </b-col>
      <b-col class="text-left">
        <h2>{{ titulo }}</h2>
        <p>{{ descricao }}</p>
          
          <!-- Link para o componente: https://www.npmjs.com/package/vue-qrcode-component -->
          <qr-code v-if="qrcode" :text="standalone" size="150" color="#000000" bg-color="#ffffff" error-level="H"></qr-code>
          
          <b-link v-else class="baixar-link" :href="standalone">Baixar App -></b-link>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

import Vue from 'vue'
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

export default {
  name: "Card",
  props: ["icone", "extensao", "titulo", "descricao", "link", "standalone", "cor", "index", "qrcode"],
  methods: {
    getUrl() {
      return require(`../assets/${this.icone}.${this.extensao}`);
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 1.5rem;
}

.card-wrapper {
  background: #ffffff;
  /* box-shadow: 20px 20px 60px #d9d9d9, -20px -20px 60px #ffffff; */
  border: none !important;
}

.card-wrapper>>>.card-body {
  min-height: 220px;
}

.card-wrapper:nth-child(3n + 1)::before {
  background: #33cccc;
}

.card-wrapper:nth-child(3n + 2)::before {
  background: #03283f;
}

.card-wrapper:nth-child(3n + 3)::before {
  background: #007fff;
}

.card-wrapper::before {
  content: "";
  width: 100%;
  height: 3px;
  position: absolute;
}

.img-card {
  min-width: 35px;
}
</style>